import { render, staticRenderFns } from "./SubirFotosGeneral.vue?vue&type=template&id=13f517e6&scoped=true"
import script from "./SubirFotosGeneral.vue?vue&type=script&lang=js"
export * from "./SubirFotosGeneral.vue?vue&type=script&lang=js"
import style0 from "./SubirFotosGeneral.vue?vue&type=style&index=0&id=13f517e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f517e6",
  null
  
)

export default component.exports